import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initGTM } from './ga';
import { APP_VERSION } from './version';

initGTM();

Sentry.init({
  dsn: environment.sentry_dsn,
  release: APP_VERSION,
  environment: environment.name,
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: ['localhost', environment.apiURL],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],
  tracesSampleRate: 1.0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
